import { apiUserInfo } from '@/service'
import { mergeStep } from '@/utils'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<IUserInfo | null>(null)
    const token = ref('')

    const loadUserInfo = mergeStep(async () => {
      const res = await apiUserInfo()
      userInfo.value = res.data
    })

    const setUserInfo = (val: IUserInfo) => {
      userInfo.value = val
    }
    const setToken = (val: string) => {
      token.value = val
    }

    const clearUserInfo = () => {
      userInfo.value = null
    }
    const clearToken = () => {
      token.value = ''
    }
    const logout = () => {
      clearUserInfo()
      clearToken()
      uni.reLaunch({
        url: '/pages/login/index',
      })
    }

    const isLogged = computed(() => !!token.value)

    return {
      userInfo,
      loadUserInfo,
      setUserInfo,
      clearUserInfo,
      isLogged,
      setToken,
      token,
      logout,
    }
  },
  {
    persist: true,
  },
)
